// De ontwerptaal van het goedgekeurde scherm, één keer opgeschreven.
//
// Elke waarde hier komt LETTERLIJK uit docs/input/frontend/V1_frontend.jsx (met
// het CHART-palet uit V2_frontend.jsx voor de nieuwe schermen). Dit bestand
// verandert niets aan het ontwerp — het voorkomt alleen dat dezelfde hex 200
// keer wordt overgetypt. Nieuwe kleuren of maten verzinnen we hier niet: staat
// het niet in de dummy, dan is het een ontwerpvraag, geen implementatiedetail.

export const font = "'Inter',-apple-system,sans-serif";

export const color = {
  ink: "#111827", // koppen, actieve knop, actieve pill
  body: "#374151", // gewone tekst, kolomwaarden
  muted: "#4b5563", // narratief
  soft: "#6b7280", // secundair label
  faint: "#9ca3af", // kolomlabels, tellingen, placeholders
  line: "#ececec", // kaartrand
  lineSoft: "#f0f0f0", // rand onder een tabelkop
  lineFaint: "#f3f4f6", // scheiding binnen een paneel
  border: "#e5e7eb", // invoerrand, scheider, paginaknop
  disabled: "#d1d5db",
  surface: "#ffffff",
  surfaceAlt: "#fafafa", // tabelkop, feedrij
  surfaceHover: "#f3f4f6", // feedrij hover
  surfaceQuote: "#f9fafb", // tldr-blok, onderwijsblok
  accentAmber: "#d97706", // Brainport-blok, waarschuwing
  accentAmberBg: "#fffbeb",
  accentBlue: "#2563eb", // trending
  accentGreen: "#059669",
  accentPurple: "#7c3aed",
  accentRed: "#dc2626",
} as const;

export const radius = {
  card: 12,
  block: 10,
  input: 8,
  quote: 8,
  pill: 99,
} as const;

export const size = {
  pageTitle: 30,
  panelTitle: 22,
  lead: 15,
  body: 14,
  meta: 13,
  label: 11,
  columnLabel: 10,
} as const;

export const weight = {
  regular: 500,
  medium: 600,
  bold: 700,
  heavy: 800,
} as const;

// Vaste maten uit de dummy — geen van deze getallen is een keuze van ons.
export const metric = {
  // B8 (owner 27-08, screenshots): het detailpaneel kreeg overal de maat van
  // het in-chat paneel — één idioom. Was min(580px,100vw) uit de dummy.
  panelWidth: "min(700px, 92vw)", // detailpaneel
  panelOpenDelay: 20, // ms — setSel -> open
  panelCloseDelay: 340, // ms — dicht -> unmount; volgt de 0,32s-beweging (28-08)
  tableHeaderHeight: 34,
  pagerButton: 36,
  scrim: "rgba(0,0,0,0.2)",
  scrimBlur: "blur(2px)",
  cardPadding: "14px 18px",
} as const;

// Herbruikbare stijlobjecten, exact zoals de dummy ze inline schrijft.
export const card = {
  background: color.surface,
  border: `1px solid ${color.line}`,
  borderRadius: radius.card,
} as const;

export const columnLabel = {
  fontSize: size.columnLabel,
  fontWeight: weight.medium,
  color: color.faint,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
} as const;

export const sectionLabel = {
  fontSize: size.label,
  fontWeight: weight.medium,
  color: color.faint,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  marginBottom: 10,
} as const;

// CHART-palet, letterlijk uit V2_frontend.jsx r. 31 — voor de drie nieuwe
// schermen, zodat die zich als onderdeel van hetzelfde dashboard lezen.
export const chart = {
  green: "#10b981",
  greenL: "#34d399",
  blue: "#3b82f6",
  blueL: "#60a5fa",
  red: "#ef4444",
  amber: "#f59e0b",
  purple: "#7c3aed",
  cyan: "#0891b2",
  teal: "#0d9488",
  slate: "#94a3b8",
  grid: "#f0f0f0",
} as const;

// De reeksvolgorde uit V2 (r. 1920) — eerst de sterke kleuren, dan de rest.
export const chartSeries = [
  chart.green,
  chart.purple,
  chart.cyan,
  chart.amber,
  chart.blue,
  "#ec4899",
  "#14b8a6",
  "#f97316",
  "#6366f1",
  "#84cc16",
] as const;
